import { createSlice } from '@reduxjs/toolkit';

import { getMeFulfilledMatcher } from '../../api/viewer.api';
import { fetchViewerDataThunk } from '../services/fetch-viewer-data';
import type { ViewerSchema } from '../types/viewer.schema';

const initialState: ViewerSchema = {
    status: 'init',
    data: null,
};

const viewerSlice = createSlice({
    name: 'viewer',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetchViewerDataThunk.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchViewerDataThunk.rejected, (state) => {
                state.status = 'error';
            })
            .addMatcher(getMeFulfilledMatcher, (state, action) => {
                state.status = 'success';
                state.data = action.payload;
            }),
});

export const { reducer: viewerReducer } = viewerSlice;
